
            <div class="d-flex justify-content-start mb-2  pl-3 ml-3" style="border-bottom: 1px dotted #bbbbbb;border-left: 1px dotted #bbbbbb; border-bottom-left-radius: 18px;">
              <button type="button" class="px-0 my-2 " style=" margin-right: 6px; border:none; background-color: transparent;">
              <img width="26px" height="26px" src="../../../../../assets/icons/search-result/comentario.svg"
                  (click)="openModal();"
                  tooltip="Comentarios" placement="bottom" style="opacity: 50%;" alt="">
              </button>
              <div class="d-flex px-1 my-2" style=" justify-content: center; align-items: center;">
                <div class="d-flex px-3"
                  style="border-left: 1px solid #bbbbbb; opacity: 50%; font-size: 8px; font-weight: 300; font-family: 'Open Sans';"
                  [ngStyle]="{'border-right': categoryId === 8 ? '' : '1px solid #bbbbbb'}">
                  <img width="26px" height="26px" src="../../../../../assets/icons/search-result/view.svg" class="m-0 mr-1"
                    style="line-height: 1;">
                  <p class="d-flex mb-0 mt-1 flex-column justify-content-center"
                    style="font-family: 'Rubik'; text-transform: lowercase;">
                    <span style="line-height: .5; font-size: 11px !important;">{{ viewsProduct }}</span>
                    <span style="line-height: 1.07; font-size: 11px !important;">views</span>
                  </p>
                </div>
              </div>

  <ng-container *ngIf="categoryId !== 8">

  <div class="d-flex content-icons px-1 my-2" (click)="openVideoModal(videoCommercial)" >
                <img
                      width="26px"
                      height="26px"
                      src="../../../../../assets/icons/search-result/video.svg"
                      class="custom-tooltip"
                      style="cursor: pointer;margin-top:1px; opacity: .5;"
                      tooltip="{{ videoCommercial === null ? 'Este producto no tiene video comercial' : 'Video comercial'}}"
                      placement="bottom">
              </div>
              <div class="d-flex content-icons px-1 my-2" style="align-items: center;  " (click)="openVideoModal(videoInstitutional)">
                <img width="26px" height="26px"
                src="../../../../../assets/icons/search-result/video_inst.svg"
                      class="custom-tooltip"
                      tooltip="{{ videoInstitutional === null ? 'Este producto no tiene video institucional' : 'Video institucional'}}"
                      placement="bottom"
                      style="cursor: pointer; margin-top: 5px; opacity: .5;" >
              </div>
               <div *ngIf="categoryId === 1" class="d-flex content-icons pl-2 ml-2" style="margin-top: 10px;height:26px;opacity: 50%;align-items: center;border-left: 1px solid #bbbbbb;font-weight:300  " (click)="openVideoModal(videoInstitutional)">
                <img width="26px" height="26px"
                src="../../../../../assets/icons/search-result/hotel/DESCARGA_FANSHEET.svg"
                      class="custom-tooltip"
                      tooltip="{{ description === null ? 'Este producto no tiene factsheet' : 'Descargar factsheet'}}"
                      placement="bottom"
                      style="cursor: pointer; margin-top: 5px; " >
              </div>
              <div *ngIf="categoryId === 6" class="d-flex content-icons pl-2 ml-2" style="margin-top: 10px;height:26px;opacity: 50%;align-items: center;border-left: 1px solid #bbbbbb;font-weight:300  " (click)="openVideoModal(videoInstitutional)">
                <img width="26px" height="26px"
                src="../../../../../assets/icons/search-result/tour/DESCARGA_ITIN_EXP.svg"
                      class="custom-tooltip"
                      tooltip="{{ description === null ? 'Este producto no tiene factsheet' : 'Descargar factsheet'}}"
                      placement="bottom"
                      style="cursor: pointer; margin-top: 5px;" >
              </div>

  </ng-container>


          </div>
            